module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_3016.10120783.png";